import React from "react";
import { stageValues } from "../../../utils/stageValues";

const StageCard = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 py-[12px] gap-[6px]">
      {stageValues.map((item, index) => {
        return (
          <div
            key={index}
            className="flex lg:items-center items-start lg:flex-row flex-col px-[16px] py-[12px] rounded-[16px] border-[1px] border-[#E2E8F0] cursor-pointer"
          >
            <div className="flex">
              <div
                className={`flex items-center justify-center px-[16px] rounded-[50%] lg:mx-[14px] bg-[#F1F5F9] text-[#64748B]`}
              >
                {index + 1}
              </div>
              <div
                className={`flex items-center justify-center p-[12px] rounded-[12px] mx-[7px] bg-[${item.bgColor}]`}
              >
                <img className="w-[20px] h-[20px]" src={item?.icon} alt="" />
              </div>
            </div>

            <div className="lg:pt-[0px] pt-[14px]">
              <h3 className="text-[16px] text-[#334155]">{item.name}</h3>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StageCard;
